import moment from 'moment';

const dateDefaultFormat = 'YYYY-MM-DD';
const datetimeDefaultFormat = 'YYYY-MM-DD HH:mm:ss';
const datetimeDefaultYear = 'YYYY';
const datetimeDefaultMonth = 'MM';

export const fetchImageMixin = {
  methods: {
    fetchImage(imageUrl = null) {
      return imageUrl || '/img/avatars/user.png';
    }
  }
}

export default {
  methods: {
    formatDate(date = undefined, format = null) {
      return (moment(date)).format(format || dateDefaultFormat);
    },
    formatDatetime(date = undefined, format = null) {
      return (moment(date)).format(format ? format : datetimeDefaultFormat);
    },
    formatDateYear(date = null) {
      return (date ? moment(date) : moment()).format(datetimeDefaultYear);
    },
    formatDateMonth(date = null) {
      return (date ? moment(date) : moment()).format(datetimeDefaultMonth);
    },
    paginate (arr, size) {
      if (!arr) {
        return [];
      }

      return arr.reduce((acc, val, i) => {
        let idx = Math.floor(i / size)
        let page = acc[idx] || (acc[idx] = [])
        page.push(val)

        return acc
      }, [])
    },
    hiddenDropdown(e) {
      const dropdowns = document.querySelectorAll('.dropdown');
      dropdowns.forEach(dropdown => {
        if (dropdown.contains(e.target)) {
          return;
        }
        dropdown.classList.remove('open');
      });
    },
    hiddenAllDropdown() {
      const dropdowns = document.querySelectorAll('.dropdown');
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    },
    convertObjectToOptions(object = {}) {
      return Object.keys(object).map(key => {
        return {
          value: parseInt(key),
          label: object[key],
        };
      });
    }
  }
}

export const buildTree = (list) => {
  if (!list) {
    return [];
  }

  let map = {}, node, roots = [], i;

  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i; // initialize the map
    list[i].children = []; // initialize the children
  }

  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parent_id !== null) {
      // if you have dangling branches check that map[node.parentId] exists
      list[map[node.parent_id]]?.children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
};
